import { euroPerMWhToCtPerKWh } from "../../../../../utils/energydata/energyUnits";
import type {
  EnergyPriceUnits,
  EnergyRevenuesListItem,
  EnergyRevenuesListResponse
} from "../../../RevenueMonitoring.types";

const MARKTWERT_KEYS = [
  "monatsmarktwert_solar",
  "monatsmarktwert_wind",
  "jahresmarktwert_solar",
  "jahresmarktwert_wind"
] as const satisfies ReadonlyArray<keyof EnergyRevenuesListItem>;

export function convertMarktwertValuesForDisplayUnit(
  energyRevenuesData: EnergyRevenuesListResponse,
  energyPriceUnit: EnergyPriceUnits
): EnergyRevenuesListResponse {
  if (energyPriceUnit === "€/MWh") {
    return energyRevenuesData;
  }

  const convertMarktwertValue = (value: number | null | undefined) =>
    value === null || value === undefined ? value : euroPerMWhToCtPerKWh(value);

  return energyRevenuesData.map((row) => {
    const convertedRow = { ...row };

    MARKTWERT_KEYS.forEach((key) => {
      if (Object.hasOwn(row, key)) {
        convertedRow[key] = convertMarktwertValue(row[key]);
      }
    });

    return convertedRow;
  });
}
